<template>
    <div class="form-horizontal modal_content p-b-0 m-b-0" v-pml-block="isLoading">
        <div class="row">
            <div class="col-sm-8 m_bottom_15" :class="{'has-error': errors['template_id']}">
                <label>{{ $t('template') }}</label>
                <pml-select v-model="template_id" :options="templates" label="title"></pml-select>
                <span class="error" v-if="errors['template_id']">{{ errors['template_id'][0] }}</span>
            </div>
            <div class="col-sm-4 m_bottom_15 t_right m-t-25">
                <span class="btn btn-white btn-sm btn_na" @click="toggleCC()" :class="{ 'active': showCC }" v-pml-tooltip="$t('carbon_copy')">{{ $t('cc') }}</span>
                <span class="btn btn-white btn-sm btn_na" @click="toggleBCC()" :class="{ 'active': showBCC }" v-pml-tooltip="$t('blind_carbon_copy')">{{ $t('bcc') }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 m_bottom_15" :class="{'has-error': errors['subject']}">
                <label>{{ $t('subject') }}</label>
                <input type="text" class="form-control" v-model="record.subject">
                <span class="error" v-if="errors['subject']">{{ errors['subject'][0] }}</span>
            </div>
        </div>
        <div class="row" v-if="showCC">
            <div class="col-sm-12 m_bottom_15" :class="{'has-error': errors['cc']}">
                <label>{{ $t('cc') }} <small class="text-muted">({{ $t('press_enter_or_tab_to_register') }})</small></label>
                <pml-autocomplete-tag-input v-model="record.cc" :unfilteredTags="record.cc" :options="emailAddresses" :type="'email'" v-pml-autocomplete-tag-input-focus></pml-autocomplete-tag-input>
                <span class="error" v-if="errors['cc']">{{ errors['cc'][0] }}</span>
            </div>
        </div>
        <div class="row" v-if="showBCC">
            <div class="col-sm-12 m_bottom_15" :class="{'has-error': errors['bcc']}">
                <label>{{ $t('bcc') }} <small class="text-muted">({{ $t('press_enter_or_tab_to_register') }})</small></label>
                <pml-autocomplete-tag-input v-model="record.bcc" :unfilteredTags="record.bcc" :options="emailAddresses" :type="'email'" v-pml-autocomplete-tag-input-focus></pml-autocomplete-tag-input>
                <span class="error" v-if="errors['bcc']">{{ errors['bcc'][0] }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 m_bottom_15" :class="{'has-error': errors['body']}">
                <label>{{ $t('message') }}</label>
                <pml-summernote v-model="record.body" :value="record.body" :show-deal-btn="false"></pml-summernote>
                <span class="error" v-if="errors['body']">{{ errors['body'][0] }}</span>
            </div>
        </div>
        <div class="d_flex flex_wrap f_justify_between">
            <div class="hidden-xs m_bottom_15">
                <router-link tag="span" :to="{ name: 'deals.show.emails', params: { id: deal.id } }" class="btn btn-white btn_na hidden-xs">{{ $t('cancel') }}</router-link>
            </div>
            <div class="d_flex flex_wrap full_w_xs f_justify_end f_justify_xs">
                <div class="d_flex flex_wrap h_34 m_bottom_15 f_justify_end w_full_450">
                    <div v-if="record.is_scheduled && !record.id" :class="{'has-error': errors['scheduled_at']}">
                        <pml-datetime-picker v-model="record.scheduled_at" v-pml-focus class="w_140"></pml-datetime-picker>
                        <span class="show error text-center" v-if="errors['scheduled_at']">{{ errors['scheduled_at'][0] }}</span>
                    </div>
                    <div v-else v-show="record.is_scheduled" :class="{'has-error': errors['scheduled_at']}">
                        <pml-datetime-picker v-model="record.scheduled_at" class="w_140"></pml-datetime-picker>
                        <span class="show error text-center" v-if="errors['scheduled_at']">{{ errors['scheduled_at'][0] }}</span>
                    </div>
                    <pml-switch v-model="record.is_scheduled" :text="$t('set_scheduling')" class="switch_text_left m-l-10 m-r-15"></pml-switch>
                </div>
                <div class="d_flex f_justify_between w_full_450 m_bottom_15">
                    <router-link tag="span" :to="{ name: 'deals.show.emails', params: { id: deal.id } }" class="btn btn-white btn_na hide visible-xs m-r-15">{{ $t('cancel') }}</router-link>
                    <button @click.prevent="askToSend()" class="btn btn-default" v-pml-block="isSaving">{{ buttonName }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { create, replace, signature, update, get } from 'services/emails'
    import { mapGetters } from 'vuex'
    import { sendEmail } from 'utils/helpers/sweet-alert'
    import { isNil, isNull } from 'lodash'

    export default {
        name: 'SendEmail',
        props: [ 'deal' ],
        data () {
            return {
                record: {
                    cc: null,
                    bcc: null,
                    body: '',
                    scheduled_at: '',
                    is_scheduled: false
                },
                template_id: '',
                errors: [],
                showCC: false,
                showBCC: false,
                isLoading: false,
                isSaving: false
            }
        },
        created () {
            this.clear()
        },
        computed: {
            ...mapGetters({
                'member': 'getMember',
                'templates': 'getTemplates',
                'emailAddresses': 'getEmailAddresses',
                'emails': 'getDealEmails'
            }),
            buttonName () {
                return this.record.is_scheduled ? trans('schedule') : trans('send')
            }
        },
        mounted () {
            this.init()
        },
        watch: {
            'template_id' (val, old) {
                if (isNull(val) || val === '') {
                    this.clear()
                } else if (val !== old) {
                    this.isLoading = true

                    replace(this.template_id, this.deal.id)
                        .then(response => {
                            this.record.subject = response.data.subject
                            this.record.body = response.data.body
                        })
                        .catch(() => Notify.error(trans('_notifications.error')))
                        .then(() => { this.isLoading = false })
                }
            },
            '$route' () {
                this.init()
            }
        },
        methods: {
            init () {
                if (typeof this.$route.params.email !== 'undefined')
                    this.fetchRecord(this.$route.params.email)
                else
                    this.clearForm()
            },
            fetchRecord (id) {
                this.isLoading = true
                get(this.deal.id, this.$route.params.email)
                    .then(response => {
                        this.errors = []
                        this.record = response.data.email
                        this.record.body = response.data.body

                        this.showCC = !isNull(this.record.cc)
                        this.showBCC = !isNull(this.record.bcc)
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => {
                        this.isLoading = false
                    })
            },
            clear () {
                this.record.subject = ''
                this.record.body = ''
                if (this.member.active_email_signature)
                    signature(this.deal.id)
                        .then(response => {
                            this.record.body = response.data.body
                        })
            },
            askToSend () {
                sendEmail()
                    .then((response) => (response.value) ? this.store() : null)
            },
            request () {
                return isNil(this.record.id) ? create(this.deal.id, this.record) : update(this.deal.id, this.record.id, this.record)
            },
            store () {
                this.isSaving = true

                this.checkCopy()
                this.request()
                    .then(response => {
                        Notify.success(trans('_notifications.success'))
                        this.$router.push({ name: 'deals.show.emails' })
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            },
            toggleCC () {
                this.showCC = !this.showCC
                this.record.cc = []
            },
            toggleBCC () {
                this.showBCC = !this.showBCC
                this.record.bcc = []
            },
            checkCopy () {
                if (!isNull(this.record.cc) && !this.record.cc.length)
                    this.record.cc = null

                if (!isNull(this.record.bcc) && !this.record.bcc.length)
                    this.record.bcc = null
            },
            clearForm () {
                this.record = {
                    cc: null,
                    bcc: null,
                    body: '',
                    scheduled_at: '',
                    is_scheduled: false
                }
                this.template_id = ''
                this.errors = []
                this.showCC = false
                this.showBCC = false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/emails/Form.vue